import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["value"]




export default /*#__PURE__*/_defineComponent({
  props: {
    modelValue: null,
    invalid: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit }: { emit: ({
  (event: 'update:modelValue', value: string): void;
}), expose: any, slots: any, attrs: any }) {





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("input", {
    value: __props.modelValue,
    onInput: _cache[0] || (_cache[0] = ($event: any) => (emit('update:modelValue', $event.target.value))),
    class: _normalizeClass(["form-control p-component p-inputtext", { 'is-invalid p-invalid': __props.invalid }])
  }, null, 42, _hoisted_1))
}
}

})